import { graphHooks } from '@tunasong/graph-lib/react'
import type { LayoutComponent } from '@tunasong/plugin-lib'
import type { Entity, Rider } from '@tunasong/schemas'
import type { FC } from 'react'
import { useCallback } from 'react'
import EditForm from '../edit-form.js'

export interface RiderEditViewProps extends LayoutComponent<Rider> {}

const RiderEditView: FC<RiderEditViewProps> = props => {
  const { entity: rider } = props

  const updateEntity = graphHooks.useEntityUpdate({ debounceDelay: 1 * 1000 })
  const handleChange = useCallback(
    (partial: Partial<Entity>) => updateEntity(rider.id, partial),
    [rider.id, updateEntity]
  )

  return <EditForm element={rider} onChange={handleChange} />
}

export default RiderEditView
